export const isBrowserEnv = typeof window !== 'undefined';
